
import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

interface ActionButtonsProps {
  handleSubscribe: () => void;
  isYearly: boolean;
}

const ActionButtons = ({ handleSubscribe, isYearly }: ActionButtonsProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-6 py-6">
      <h3 className="text-2xl font-bold text-corporate-primary-100 mb-2">Ready to Make Your Choice?</h3>
      <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
        <Button 
          className="bg-corporate-primary-100 hover:bg-corporate-primary-75 text-white px-6 sm:px-12 py-6 text-base sm:text-lg font-medium relative overflow-hidden group min-h-[56px] shadow-md hover:shadow-lg rounded-lg"
          onClick={handleSubscribe}
        >
          <div className="relative z-10 flex items-center justify-center gap-2">
            <Star className="w-5 h-5" />
            <span>Subscribe to Premium {isYearly ? '(Yearly)' : '(Monthly)'}</span>
          </div>
          <div className="absolute inset-0 bg-corporate-primary-75 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
        </Button>
        <Button
          variant="outline"
          className="border-corporate-primary-100 text-corporate-primary-100 hover:bg-corporate-primary-100 hover:text-white px-6 sm:px-12 py-6 text-base sm:text-lg font-medium min-h-[56px] rounded-lg"
          asChild
        >
          <Link to="/auth">Explore Marketplace</Link>
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;
